<template>
  <div>
    <template-one ref="templateOne" v-if="style === 1" />
    <template-two ref="templateTwo" v-if="style === 2" />
    <div v-else-if="style === 3"></div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import TemplateOne from './components/TemplateOne.vue'
import TemplateTwo from './components/TemplateTwo.vue'
export default {
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        {
          name: 'keywords',
          content: this.meta.keywords
        },
        {
          name: 'description',
          content: this.meta.description
        }
      ]
    }
  },
  components: {
    TemplateOne,
    TemplateTwo
  },
  data() {
    return {
      style: 1,
      meta: {
        title: 'Album',
        keywords: '',
        description: ''
      }
    }
  },
  watch: {
    '$route.query.moduleId'(value) {
      this.getAlbumModuleGroup()
    },
    '$route.query.keywords'(value) {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const keywords = this.$route.query.keywords
      if (keywords) {
        API.getSeoBusinessId({ seoSearchTerm: keywords, type: 2 }).then(res => {
          let data = res.data || {}
          this.meta.title = data.seoTitle
          this.meta.description = data.seoDescription
          this.meta.keywords = data.seoKeyWords
          this.getAlbumModuleGroup(data.businessId)
        })
        return
      }
      this.getAlbumModuleGroup()
    },
    // 专辑分组
    getAlbumModuleGroup(moduleId) {
      API.getAlbumModuleGroup({ moduleId: moduleId || this.$route.query.moduleId }).then(res => {
        this.style = res.data.style
        this.$nextTick(() => {
          switch (this.style) {
            case 1:
              this.$refs.templateOne.init(res.data, moduleId)
              break
            case 2:
              this.$refs.templateTwo.init(res.data, moduleId)
              break
            default:
              this.$refs.templateOne.init(res.data, moduleId)
              break
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
